<template>  
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>    
    <Migalha label="Relatórios"></Migalha>

    <v-layout row wrap v-show="showBox">
     <!-- <v-flex v-if="!flExibirFormAddDocumento && $verificaPerfilHabilitador()"  xs12 sm12 md12 class="text-xs-right p-l-10">
        <v-btn fab small color="primary" @click="flExibirFormAddDocumento = true;">
           <v-icon>add</v-icon>
        </v-btn>
      </v-flex>

       <template v-if="flExibirFormAddDocumento">        
         <v-flex xs12 sm12 md12 infoDados>
          <v-card>
            <div>
              <div class="p-t-none">
                <div class="tituloBox">
                  <div class="bg-red barraTitulo"></div>
                  <h1 class="text-default font-size-14">
                    <strong>Adicionar Documento</strong>
                  </h1>
                </div>
              </div>
              <div class="clear"></div>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs7 sm7 md7>
                    <v-text-field
                      v-model="arquivo.nomDocumento"
                      maxlength="200"
                      label="Nome do documento *"
                      :rules="[() => !!arquivo.nomDocumento || 'Campo é obrigatório']"
                      required
                      validate-on-blur
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 sm5 md5>
                    <uploadFile
                      tamanhoMaximo="20MB"
                      label="Anexar Documento *"
                      :rules="[() => !!arquivo.file || 'Campo é obrigatório']"
                      required
                      v-model="arquivo.file"
                      accept=".pdf, .PDF"
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
          </v-card>
        </v-flex> -->

        <!-- <v-layout row d-inline class="p-t-10">
          <v-flex right>
            <v-btn color="info" @click="salvarDocumento();">Salvar</v-btn>
          </v-flex>
          <v-flex right>
            <v-btn @click="flExibirFormAddDocumento = false; limparArquivo()">Cancelar</v-btn>
          </v-flex>
        </v-layout> -->
      <!-- </template> -->

      <v-flex v-if="!flExibirFormAddDocumento" infoDados>
        <v-card>
          <div v-if="documentosRelatorios">
            <div class="filtros-relatorios p-b-20 p-t-10">
              <v-layout row wrap align-center justify-space-between>
                <!-- Data Inicial -->
                <v-flex xs12 sm6 md3>
                  <v-menu
                    v-model="menuDataInicial"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filtros.dataInicialFormatada"
                        label="Data Inicial"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.dataInicial"
                      no-title
                      @input="menuDataInicial = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <!-- Data Final -->
                <v-flex xs12 sm6 md3>
                  <v-menu
                    v-model="menuDataFinal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filtros.dataFinalFormatada"
                        label="Data Final"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.dataFinal"
                      no-title
                      @input="menuDataFinal = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <!-- Dropdown Analista -->
                <v-flex xs12 sm6 md3>
                  <v-select
                    v-model="filtros.analistaId"
                    :items="analistas"
                    item-text="nome"
                    item-value="id"
                    label="Analista"
                    placeholder="Todos os analistas"
                    clearable
                  ></v-select>
                </v-flex>

                <!-- ✅ NOVO: Dropdown Relatório -->
                <v-flex xs12 sm6 md3>
                  <v-select
                    v-model="filtros.relatorioTipo"
                    :items="documentosRelatorios"
                    item-text="nome"
                    item-value="tipo"
                    label="Relatório"
                    placeholder="Todos os relatórios"
                    clearable
                  ></v-select>
                </v-flex>

                <!-- Botão Gerar Relatório -->
                <v-flex xs12 sm6 md3>
                  <v-btn 
                    color="primary" 
                    @click="gerarRelatorio"
                    block 
                    large
                    :loading="loading"
                    class="btn-gerar-relatorio"
                    elevation="2"
                  >
                    <v-icon left>file_download</v-icon>
                    Gerar Relatório
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <div class="p-t-none">
              <div class="tituloBox">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14">
                  <strong>Relatórios</strong>
                </h1>
              </div>
            </div>

            <div class="clear"></div>

            <v-data-table
              :headers="headers"
              :items="documentosRelatoriosFiltrados"
              :loading="loading"
              :hide-actions="true"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.nome }}</td>
                <td class="text-xs-center">{{ props.item.dataCriacao | dataFormatada }}</td>
                <td class="text-xs-center naoImprimir">
                  <!-- @click="exportarExcel()"   -->
                  <a @click="exportarExcel(props.item, props.item.tipo)" color="info" > 
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                    width="24" height="24"
                    viewBox="0 0 192 192"
                    style=" fill:#000000;">
                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#2ecc71">
                    <path d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z">
                    </path>
                    </g></g>
                    </svg>
                  </a>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <v-dialog v-model="dialogDelete" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirmar Exclusão</v-card-title>

        <v-card-text>
          <p>Tem certeza que deseja deletar este documento?</p>
        </v-card-text>

        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn color="default" @click="dialogDelete = false">Cancelar</v-btn>
          </v-flex>

          <v-flex sm6>
            <v-btn color="info" @click="excluirDocumento()">Confirmar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import Topo from "../../../components/Topo";
import Migalha from "../../../components/migalha";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import arquivoService from "../../../services/arquivoService";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import usuarioService from "../../../services/usuarioService";
import Vue from 'vue';

export default {
  name: "guias-orientacoes",
  mixins: [util],
  components: {
    /*Componentes utilizados*/
    Migalha,
    Topo,
  },
  data() {
    //Declaracao de variaveis
    return {
      Vue: Vue,
      dialogDelete: false,
      idExclusao: null,
      showBox: true,
      valid: true,
      documentos: [],
      documentosRelatorios: [
        { 
          descricao: 'Relatório Quantitativo de Solicitações',
          nome: 'Relatório Quantitativo de Solicitações',
          tipo: 1,
        },
        { 
          descricao: 'Relatório Quantitativo de Documentos Aprovados e Rejeitados',
          nome: 'Relatório Quantitativo de Documentos Aprovados e Rejeitados',
          tipo: 5,
        },
        { 
          descricao: 'Relatório Quantitativo de Motivos de Indeferimento',
          nome: 'Relatório Quantitativo de Motivos de Indeferimento',
          tipo: 2,
        },
        { 
          descricao: 'Relatório Tempo de Análise por Solicitações',
          nome: 'Relatório Tempo de Análise por Solicitações',
          tipo: 3,
        },
        { 
          descricao: 'Relatório Base Solicitações',
          nome: 'Relatório Base Solicitações',
          tipo: 4,
        },
        { 
          descricao: 'Relatório Dupla Conferência',
          nome: 'Relatório Dupla Conferência',
          tipo: 6,
        },
      ],
      model: {
        opcaoRelatorioEscolhido: null,
      },
      arquivo: {
        nomDocumento: null,
        usuarioId: null,
        file: null,
      },
      loading: false,
      flExibirFormAddDocumento: false,
      headers: [
        /*Cabeçalho da data-table*/
        {
          text: this.$t("label.nome"),
          align: "left",
          sortable: false,
          width: 300,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          width: 70,
        },
        {
          text: this.$t("label.anexo"),
          align: "center",
          sortable: false,
          width: 120,
          class: "naoImprimir",
        },
      ],
      menuDataInicial: false,
      menuDataFinal: false,
      analistas: [],
      filtros: {
        dataInicial: null,
        dataFinal: null,
        dataInicialFormatada: '',
        dataFinalFormatada: '',
        analistaId: null,
        relatorioTipo: null,
        }
    };
  },

  computed: {
    // Filtra a lista exibida na tabela
    documentosRelatoriosFiltrados() {
      if (this.filtros && this.filtros.relatorioTipo) {
        return (this.documentosRelatorios || []).filter(r => r.tipo === this.filtros.relatorioTipo);
      }
      return this.documentosRelatorios || [];
    }
  },

  watch: {
    "filtros.dataInicial"(val) {
      this.filtros.dataInicialFormatada = val ? this.formatarData(val) : "";
      if (val && this.filtros.dataFinal) this.carregarAnalistas();
    },
    "filtros.dataFinal"(val) {
      this.filtros.dataFinalFormatada = val ? this.formatarData(val) : "";
      if (val && this.filtros.dataInicial) this.carregarAnalistas();
    }
  },

  async created() {
    await this.obterDocumentos();
  },

  methods: {
    
    formatarData(val) {
      // val vem no formato 'YYYY-MM-DD' do v-date-picker
      if (!val) return null;
      const [ano, mes, dia] = val.split('-');
      return `${dia}/${mes}/${ano}`;
    },

    // NOVO: Carrega analistas APÓS datas preenchidas
    async carregarAnalistas() {
      if (this.filtros.dataInicial && this.filtros.dataFinal) {
        this.loading = true;
        try {
          // API endpoint para analistas (ajuste conforme backend)
          const analistas = (await usuarioService.getUsuariosHabilitador()).data;
          
          this.analistas = analistas || [
            { id: null, nome: 'Todos os analistas' },
            { id: 1, nome: 'João Silva' },
            { id: 2, nome: 'Maria Santos' }
          ];
        } catch (error) {
          console.error('Erro ao carregar analistas:', error);
          this.analistas = [{ id: null, nome: 'Todos os analistas' }];
        } finally {
          this.loading = false;
        }
      }
    },

    gerarRelatorio() {
      if (this.filtros.dataInicial && this.filtros.dataFinal &&
          this.filtros.dataInicial > this.filtros.dataFinal) {
        this.$toasted.error('Data inicial não pode ser maior que data final');
        return;
      }

      // Se o usuário escolheu um relatório, exporta aquele tipo; se não, mantém comportamento atual (UI mostra todos).
      const tipo = this.filtros.relatorioTipo;

      if (!tipo) {
        // Opcional: pode exportar "padrão" (ou exigir seleção). Mantive opcional e não quebrei a tela:
        this.$toasted.error('Selecione um relatório para gerar o Excel.');
        return;
      }

      this.loading = true;

      try {

        const payload = {
          dataInicial: this.filtros.dataInicial,
          dataFinal: this.filtros.dataFinal,
          usuarioAnalistaId: this.filtros.analistaId,     
          opcaoRelatorioEscolhido: tipo                   
        };

        fornecedorService.exportarExcel(payload, 4);
      } finally {
        this.loading = false;
      }
    },

    // ATUALIZAR exportarExcelComFiltros()
    exportarExcelComFiltros() {
          if (this.filtros.dataInicial && this.filtros.dataFinal &&
              this.filtros.dataInicial > this.filtros.dataFinal) {
            this.$toasted.error('Data inicial não pode ser maior que data final');
            return;
          }
          
          this.loading = true;
          console.log("Mostre:", this.filtros);
          fornecedorService.exportarExcel({
          dataInicial: this.filtros.dataInicial,
          dataFinal: this.filtros.dataFinal,
          usuarioAnalistaId: this.filtros.usuarioAnalistaId,
          opcaoRelatorioEscolhido : this.filtros.relatorioTipo
        }, 4);
        this.loading = false;
        },
      

      //Declaracao de todos os metodos
      exportarExcel(item, opcaoRelatorio){
        // 4 - gera excel de solicitações da tela de relatorios.
        
        //opcao do relatorio selecionado
        this.model.item = item;
        this.model.opcaoRelatorioEscolhido = opcaoRelatorio;

        this.model.dataFinal = this.filtros.dataFinal;
        this.model.usuarioAnalistaId = this.filtros.analistaId;

        // segundo paramentro indica o tipo de rota usada para gerar o relatorio
        fornecedorService.exportarExcel(this.model, 4);
      },
  
      async obterDocumentos() {
        await arquivoService.obterDocumentosGuias().then((result) => {
          this.documentos = result.data;
        });
      },
      async salvarDocumento() {
        if (this.$refs.form.validate() && this.$verificaPerfilHabilitador()) {
          this.arquivo.usuarioId = this.$store.getters.getUsuarioId;
          await arquivoService.salvar(this.arquivo).then((result) => {
            this.obterDocumentos();
            this.limparArquivo();
            this.flExibirFormAddDocumento = false;
            this.$toasted.success(result.data);
          });
        }
      },
      async excluirDocumento() {
        if(this.$verificaPerfilHabilitador()) {
          await arquivoService.excluirDocumento(this.idExclusao).then((result) => {
            this.obterDocumentos();
            this.dialogDelete = false;
            this.$toasted.success(result.data);
          });
        }
      },
      async limparArquivo() {
        this.arquivo.file = null;
        this.arquivo.nomDocumento = null;
      }
   },
  };

</script>
<style>
.btn.focus, .btn:focus, .san {
    outline: 0;
    box-shadow: none!important;
    border: none;
}
.inputIcon {
  position: relative;
}

.inputIcon [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.inputIcon .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.inputIcon .v-text-field__slot {
  border-right: 0;
}

.inputIcon .v-input__icon--clear {
    border-radius: 0;
		border-right: 0 none !important;
}

.inputIcon .v-input__icon {
  align-self: center !important;
  min-height: 50px;
  border: solid 1px #eee;
  border-left: none;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}

.filtros-relatorios {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;
  margin-bottom: 20px;
}

.btn-gerar-relatorio {
  height: 54px !important;  /* Altura igual aos inputs */
  min-width: 180px !important;
}

.v-layout.align-center .v-btn {
  margin-top: 0 !important;  /* Remove margem superior */
}

/* Responsivo: botão sempre centralizado verticalmente */
@media (max-width: 960px) {
  .filtros-relatorios .v-layout > .v-flex:last-child {
    margin-top: 16px;
  }
}
</style>
